import { startOfLocalDay } from '../../../../services/dateUtils';
import { getEventPublicCategories } from '../../../../services/events/eventDisplayFields';

export const HALLOWEEN_CATEGORY = 'Halloween';

/** Local calendar window: 24 October through the end of 2 November. */
const START_MONTH = 9;
const START_DAY = 24;
const END_MONTH = 10;
const END_DAY = 2;

function seasonBounds(now) {
  const year = now.getFullYear();
  return {
    start: new Date(year, START_MONTH, START_DAY),
    end: new Date(year, END_MONTH, END_DAY + 1),
  };
}

/** True from the start of 24 Oct through the end of 2 Nov, local time. */
export function isHalloweenSeason(now = new Date()) {
  const when = now instanceof Date && !Number.isNaN(now.getTime()) ? now : new Date();
  const { start, end } = seasonBounds(when);
  const time = when.getTime();
  return time >= start.getTime() && time < end.getTime();
}

/**
 * Inclusive start, exclusive end. Days already over are dropped, so the
 * window starts today once the season has begun.
 */
export function halloweenRange(now = new Date()) {
  const when = now instanceof Date && !Number.isNaN(now.getTime()) ? now : new Date();
  const today = startOfLocalDay(when);
  const { start, end } = seasonBounds(when);
  return { start: today.getTime() > start.getTime() ? today : start, end };
}

/** Submenu on the events list, Halloween, and Giveaways, and only in season. */
export function shouldShowEventsSubNav(pathname, now = new Date()) {
  if (!isHalloweenSeason(now)) return false;
  const path = String(pathname || '');
  return path === '/' || path === '/halloween' || path === '/events/halloween' || path === '/giveaway';
}

/** True when the event is tagged Halloween, or has no tags and the word is in the text. */
export function isHalloweenEvent(event) {
  return getEventPublicCategories(event).some(
    (label) => String(label || '').trim().toLowerCase() === HALLOWEEN_CATEGORY.toLowerCase()
  );
}

/** 31 October keeps a fixed label. Other days use the normal separator. */
export function halloweenGroupLabel(day, fallback) {
  if (
    day instanceof Date
    && !Number.isNaN(day.getTime())
    && day.getMonth() === START_MONTH
    && day.getDate() === 31
  ) {
    return 'HALLOWEEN NIGHT';
  }
  return fallback;
}
